var groups = {
    crm: {
        id: 'crm',
        label: Loc.g('Contact'),
        permissionRoute: '/rest/thirds/listing/permissions',
        listings: [
            {
                id: "client",
                label: Loc.g("Clients"),
                route: "client",
                permission: 'can_list_clients'
            },
            {
                id: "prospect",
                label: Loc.g("Prospects"),
                route: "prospect",
                permission: 'can_list_prospects'
            },
            {
                id: "supplier",
                label: Loc.g("Fournisseurs"),
                route: "supplier",
                permission: 'can_list_suppliers'
            },
            {
                id: "company",
                label: Loc.g("Sociétés"),
                route: "company",
                permission: 'can_list_companies'
            },
            {
                id: "individual",
                label: Loc.g("Particuliers"),
                route: "individual",
                permission: 'can_list_individuals'
            },
            {
                id: "people",
                label: Loc.g("Contacts"),
                route: "people",
                permission: 'can_list_peoples'
            },
        ]
    },
    sales: {
        id: 'sales',
        label: Loc.g('Facturation'),
        permissionRoute: '/rest/sales/listing/permissions',
        listings: [
            {
                id: "estimate",
                label: Loc.g("Devis"),
                route: "estimate",
                permission:  "show_estimate_list",
            },
            {
                id: "invoice",
                label: Loc.g("Factures"),
                route: "invoice",
                permission: "show_invoice_list",
            },
            {
                id: "creditnote",
                label: Loc.g("Avoirs"),
                route: "creditnote",
                permission: "show_creditnote_list",
            },
            {
                id: "proforma",
                label: Loc.g("Proforma"),
                route: "proforma",
                permission: 'show_proforma_list'
            },
        ]
    },
    drafts: {
        id: 'drafts',
        label: Loc.g('Brouillons'),
        permissionRoute: '/rest/sales/listing/permissions',
        listings: [
            {
                id: "invoicedraft",
                label: Loc.g("Factures brouillon"),
                route: "invoicedraft",
                permission: "show_invoice_list",
            },
            {
                id: "creditnotedraft",
                label: Loc.g("Avoirs brouillon"),
                route: "creditnotedraft",
                permission: "show_creditnote_list",
            },
        ]
    },
    purchase: {
        id: 'purchase',
        label: Loc.g('Factures fournisseur'),
        permissionRoute: '/rest/purchase/listing/permissions',
        listings: [
            {
                id: 'purchase.incoming',
                label: Loc.g('À vérifier'),
                route: 'purchase.incoming',
                permission: 'show_purchase_invoice_ocr_list',
            },
            {
                id: 'purchaseinvoices',
                label: Loc.g('Factures vérifiées'),
                route: 'purchaseinvoices',
                permission: 'show_purchase_invoice_list',
            },
        ],
    },
};

export default groups
